module.exports = __webpack_public_path__ + "img/short_text.147602af.svg";